// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import { HeaderContainer } from './style';
import { Logo } from './components/logo';
import { Icon } from './components/icon';
import { Avatar } from './components/avatar';
import { ProfileMenu } from './components/profile-menu';
import { DownloadDrawerButton } from '../../../download-center/download-drawer-button';
import { ChatDrawerButton } from '../../../chat/chat-drawer-button';
export const HeaderComponent = ({ logout, openLangMenu, openAssistanceMenu, openTenantMenu, toggleSideMenu, openDownloadMenu, openChatMenu, user, menu, isOpenSideMenu, navigate, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const openProfileMenu = () => {
        setIsOpen(!isOpen);
    };
    return (React.createElement(HeaderContainer, null,
        React.createElement("div", { className: `main-menu` },
            React.createElement("div", { className: "main-menu_left-components" },
                !!menu?.length && (React.createElement(Icon, { onClick: toggleSideMenu, isOpen: isOpenSideMenu })),
                React.createElement(Logo, { onClick: () => navigate('/') })),
            React.createElement("div", { className: "main-menu_actions" },
                React.createElement(ChatDrawerButton, { onClick: openChatMenu }),
                React.createElement(DownloadDrawerButton, { onClick: openDownloadMenu }),
                React.createElement(Avatar, { user: user, onClick: openProfileMenu }),
                React.createElement(ProfileMenu, { user: user, open: isOpen, logout: logout, openLangMenu: openLangMenu, openAssistanceMenu: openAssistanceMenu, openTenantMenu: openTenantMenu, onClose: () => setIsOpen(false) })))));
};
//# sourceMappingURL=component.js.map